import { Component, Pipe } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { RoutesPath } from '../../../shared/constants/routes-path';
import { environment } from '../../../../environments/environment';
import { serviceData } from '../../../data/DCGJProcess';
import { serviceDataArabic } from '../../../data/DCGJProcessArabic';
import { SharedService } from '../../../shared/services/shared.service';
import { ApiService } from '../../../core/services/api.service';
import { FieldValue, ServiceNameAr, ServiceNameEn, UserType } from '../../../shared/constants/services.enum';
import { ValidationMessageComponent } from "../../../shared/components/validation-message/validation-message.component";
import { ApiEndPoints, ApiRoot } from '../../../shared/constants/api-endpoints';
import { Utils } from '../../../Utils/utils';
import { DcMethodValues } from '../../../shared/constants/dc-method.constants';
@Pipe({ name: 'filterFav' })
export class FilterFavPipe {
  // This method is used to transform using list and fav only
  transform(list: any[], favOnly: boolean) {
    return favOnly ? list.filter((i) => i.favourite) : list;
  }
}
@Pipe({ name: 'filterSearch' })
export class FilterSearchPipe {
  // This method is used to transform using list and q
  transform(list: any[], q: string) {
    return q
      ? list.filter((i) =>
        i.serviceName.toLowerCase().includes(q.toLowerCase())
      )
      : list;
  }
}
@Component({
  selector: 'app-all-services',
  imports: [TranslateModule, ButtonComponent, FormsModule, ValidationMessageComponent],
  templateUrl: './all-services.component.html',
  styleUrl: './all-services.component.scss',
})
export class AllServicesComponent {
  showFavOnly: boolean = false;
  ServicesMenu: any = [];
  search = '';
  hideMembership = false;
  showFavouriteButton = environment.mVP1Settings?.showFavouriteButton ?? false;
  lang: string = "en";
  favLoading = false;
  favProfileLoading = false;
  favouriteNames: string[] = [];
  favouriteKeys = new Set<string>();
  serviceAccessFlags: Record<string, string> = {};
  primaryAccount: any = null;

  constructor(private router: Router,
    private sharedService: SharedService,
    private api: ApiService
  ) {
    this.primaryAccount = this.sharedService.getPrimaryAccount();
    this.lang = this.sharedService.getCurrentLang() || "en";
    this.ServicesMenu = this.buildFromServiceData();
    this.fetchFavouriteServices();
  }

  // This method is used to build from service data
  private buildFromServiceData() {
    const groupsMap = new Map<string, any>();
    const source: any = this.lang === 'ar' ? serviceDataArabic : serviceData;
    const englishItems = serviceData?.Items || [];
    const favouriteNameById = new Map<string, string>();
    for (const enItem of englishItems) {
      const [groupRaw, nameRaw] = String(enItem.SRType || '').split('||');
      const serviceName = (enItem.serviceName || nameRaw || '').trim();
      const serviceNameKey = enItem.serviceNameKey as keyof typeof ServiceNameEn | undefined;
      const enumName = serviceNameKey ? ServiceNameEn[serviceNameKey] : '';
      if (enItem?.id && (enumName || serviceName)) {
        favouriteNameById.set(enItem.id, enumName || serviceName);
      }
    }
    const items = source?.Items || [];
    for (const it of items) {
      if (it?.Visible === false) continue; // respect visibility flag
      const [groupRaw, nameRaw] = String(it.SRType || '').split('||');
      const groupName = (groupRaw || '').trim();
      const serviceName = (nameRaw || '').trim();
      if (!groupName || !serviceName) continue;
      if (!groupsMap.has(groupName)) {
        groupsMap.set(groupName, {
          groupName,
          isOpen: false,
          active: true,
          description: '',
          parentServiceName: this.getParentServiceName(it),
          services: [] as any[],
        });
      }
      const group = groupsMap.get(groupName)!;
      const favouriteName = favouriteNameById.get(it.id) || serviceName;
      
      // if (!this.primaryAccount?.['DC HI Start Date'] && it.id === 'mrm-award') continue; // Hide MRM service not HI start date

      group.services.push({
        id: it.id,
        serviceName,
        serviceNameKey: it.serviceNameKey,
        serviceNameEn: favouriteName,
        parentServiceKey: it.parentServiceKey,
        accessFlagKey: it.accessFlagKey,
        routerLink: undefined, // optional; map later if needed
        favourite: false,
        active: true,
        description: it.PreText || '',
        serviceNameTranslation: it.serviceNameForList
      });
    }
    // Make the first group open by default
    // drop empty groups
    let groups = Array.from(groupsMap.values()).filter(
      (g) => (g.services?.length ?? 0) > 0
    );
    // Move Membership Services group to the front
    const idx = groups.findIndex((g) => g.groupName === 'Membership');
    if (idx > 0) {
      const [ms] = groups.splice(idx, 1);
      groups = [ms, ...groups];
    }
    // ensure only first is open by default
    groups.forEach((g, i) => (g.isOpen = i === 0));
    return groups;
  }

  /** ------------- computed list ------------- */
  // This method is used to groups filtered old
  get groupsFiltered_old() {
    let userType = this.sharedService.getPrimaryAccount()['Account Type Code'];
    const q = (this.search || '').toLowerCase().trim();
    // This method is used to filter service using s
    const filterService = (s: any) =>
      (!this.showFavOnly || s.favourite) &&
      (q === '' || (s.serviceName || '').toLowerCase().includes(q));
    const groups: any[] = [];
    for (const g of this.ServicesMenu || []) {
      g.visibleServices = (g.services || []).filter(filterService);
      if ((g.visibleServices?.length ?? 0) > 0) groups.push(g);
    }
    return groups;
  }

  // This method is used to groups filtered
  get groupsFiltered() {
    const userType = this.sharedService.getPrimaryAccount()?.['Account Type Code'];
    const q = (this.search || '').toLowerCase().trim();

    // This method is used to filter service using s
    const filterService = (s: any) => {
      const serviceName = (s.serviceName || '').toLowerCase();

      // Exclude "Personal Effects" for Members
      if (userType === UserType.MEMBER && serviceName === 'personal effects') {
        return false;
      }

      // Exclude COO-related services for non-Members
      if (
        userType !== UserType.MEMBER &&
        (serviceName === 'issue new coo' ||
          serviceName === 'issue gsp certificate' ||
          s.id === 'coo-amendment')
      ) {
        return false;
      }

      if (
        userType !== UserType.MEMBER &&
        (serviceName === 'authenticate certificate' ||
          serviceName === 'true copy')
      ) {
        return false;
      }
      if (this.showFavOnly && !s.favourite) {
        return false;
      }

      if (q && !serviceName.includes(q)) {
        return false;
      }

      return true;
    };

    const groups: any[] = [];
    for (const g of this.ServicesMenu || []) {

      g.visibleServices = (g.services || []).filter(filterService);

      if ((g.visibleServices?.length ?? 0) > 0) {
        groups.push(g);
      }
    }

    return groups;
  }

  // This method is used to handle fav toggle using value
  onFavOnlyChange(value: boolean): void {
    this.showFavOnly = value;
    if (value) {
      this.fetchFavouriteServices();
    }
  }

  private fetchFavouriteServices(): void {
    const accountId = this.getPrimaryAccountId();
    if (!accountId) {
      this.loadUserProfileForFavourites((loadedAccountId) => {
        this.fetchFavouriteServicesById(loadedAccountId);
      });
      return;
    }
    this.fetchFavouriteServicesById(accountId);
  }

  private fetchFavouriteServicesById(accountId: string): void {
    if (!accountId) {
      this.applyFavouriteNames(new Set());
      return;
    }

    const requestPayload = {
      body: {
        ProcessName: 'DC User Favorite Services WF',
        'DC Channel': this.lang == 'ar' ? FieldValue.CHANEL_ONLINE_AR : FieldValue.CHANEL_ONLINE_EN,
        'DC Method': 'GETFAVOURITES',
        'Account Id': accountId
      }
    };

    this.favLoading = true;
    this.api.post(ApiRoot.DCCICPIntegration, ApiEndPoints.RUN_PROCESS, requestPayload)
      .subscribe({
        next: (response: any) => {
          this.logResponseErrorMessage(response, 'GETFAVOURITES');
          this.serviceAccessFlags = response || {};
          this.sharedService.setServiceAccessFlags(this.serviceAccessFlags);
          const favListRaw = response?.SiebelMessage?.['DC User Thin']?.['DC My Favorite List'];
          const favList = Utils.checkIsArray(favListRaw);
          const favourites = favList.filter((item: any) => item?.['DC Favourite Service Flag'] === 'Y');
          const favSet = new Set<string>();
          favourites.forEach((item: any) => {
            const name = this.normalizeFavouriteName(item?.['DC Favourite Service Name'] || '');
            const parent = this.normalizeFavouriteName(item?.['DC Parent Service Name'] || '');
            if (name && parent) {
              favSet.add(`${parent}||${name}`);
            }
          });
          this.favouriteKeys = favSet;
          this.applyFavouriteNames(favSet);
        },
        error: () => {
          this.serviceAccessFlags = {};
          this.sharedService.setServiceAccessFlags(this.serviceAccessFlags);
          this.favouriteNames = [];
          this.favouriteKeys = new Set();
          this.applyFavouriteNames(new Set());
        },
        complete: () => {
          this.favLoading = false;
        }
      });
  }

  private applyFavouriteNames(favSet: Set<string>): void {
    for (const group of this.ServicesMenu || []) {
      for (const service of group.services || []) {
        const matchNameByKey = this.normalizeFavouriteName(this.getFavouriteServiceName(service));
        const matchParent = this.normalizeFavouriteName(this.getParentServiceName(service, true));
        const combinedKey = matchParent && matchNameByKey ? `${matchParent}||${matchNameByKey}` : '';
        service.favourite = !!combinedKey && favSet.has(combinedKey);
      }
    }
  }

  private normalizeFavouriteName(name: string): string {
    return (name || '').toLowerCase().trim();
  }

  private getParentServiceName(service: any, changeInfoParent=false): string {
    let parentKey = service?.parentServiceKey as keyof typeof ServiceNameEn | undefined;
    const lang = this.sharedService.getCurrentLang()
      || localStorage.getItem('selectedLang')
      || this.lang
      || 'en';
    if (parentKey) {
      if(parentKey === 'INFORMATION_AND_CERTIFICATES_SERVICES' && changeInfoParent){
         parentKey ="INFORMATION_SERVICES";
      }
      if (lang === 'ar') {
        return (ServiceNameAr as any)[parentKey] || '';
      }
      return (ServiceNameEn as any)[parentKey] || '';
    }
    return '';
  }

  private getFavouriteServiceName(service: any): string {
    const serviceNameKey = service?.serviceNameKey as keyof typeof ServiceNameEn | undefined;
    const lang = this.sharedService.getCurrentLang()
      || localStorage.getItem('selectedLang')
      || this.lang
      || 'en';
    if (serviceNameKey) {
      if (lang === 'ar') {
        return (ServiceNameAr as any)[serviceNameKey] || service.serviceName || service.serviceNameEn || '';
      }
      return (ServiceNameEn as any)[serviceNameKey] || service.serviceNameEn || service.serviceName || '';
    }
    if (lang === 'ar') {
      return service.serviceName || service.serviceNameEn || '';
    }
    return service.serviceNameEn || service.serviceName || '';
  }

  private submitFavouriteServices(): void {
    const accountId = this.getPrimaryAccountId();
    if (!accountId) {
      this.loadUserProfileForFavourites((loadedAccountId) => {
        this.submitFavouriteServicesById(loadedAccountId);
      });
      return;
    }
    this.submitFavouriteServicesById(accountId);
  }

  private submitFavouriteServicesById(accountId: string): void {
    if (!accountId) {
      return;
    }
    const serviceEntries = (this.ServicesMenu || []).flatMap((group: any) =>
      (group.services || []).map((service: any) => ({
        'DC Parent Service Name': this.getParentServiceName(service, true),
        'DC Favourite Service Name': this.getFavouriteServiceName(service),
        'DC Favourite Service Flag': service.favourite ? 'Y' : 'N'
      }))
    );

    const requestPayload = {
      body: {
        ProcessName: 'DC User Favorite Services WF',
        'DC Channel': this.lang == 'ar' ? FieldValue.CHANEL_ONLINE_AR : FieldValue.CHANEL_ONLINE_EN,
        'DC Method': 'SETFAVOURITES',
        'Account Id': accountId,
        SiebelMessage: {
          MessageType: 'Integration Object',
          IntObjectName: 'DCMyFavouriteListIO',
          IntObjectFormat: 'Siebel Hierarchical',
          ListOfDCMyFavouriteListIO: {
            'DC My Favourite List': serviceEntries
          }
        }
      }
    };

    this.api.post(ApiRoot.DCCICPIntegration, ApiEndPoints.RUN_PROCESS, requestPayload)
      .subscribe({
        next: (response: any) => {
          this.logResponseErrorMessage(response, 'SETFAVOURITES');
          this.fetchFavouriteServicesById(accountId);
        },
        error: () => {
          this.fetchFavouriteServicesById(accountId);
        }
      });
  }

  private getPrimaryAccountId(): string | null {
    const primaryAccount = this.sharedService.getPrimaryAccount();
    const primaryAccountId = primaryAccount?.['Primary Organization Id'] || primaryAccount?.Id;
    if (primaryAccountId) {
      return primaryAccountId;
    }

    const profile = this.sharedService.getUserProfile();
    const accounts = Utils.checkIsArray(profile?.Account);
    const primaryCsn = profile?.['Primary CSN'];
    const matchedAccount = accounts.find((acc: any) => acc.CSN === primaryCsn) || accounts[0];
    return matchedAccount?.Id || matchedAccount?.['Primary Organization Id'] || null;
  }

  private loadUserProfileForFavourites(onReady: (accountId: string) => void): void {
    if (this.favProfileLoading) {
      return;
    }
    this.favProfileLoading = true;
    const requestPayload = {
      body: {
        ProcessName: 'DC Get User Profile Details Web WF',
        'DC Method': DcMethodValues.ALL_SERVICES,
        'DC Channel': this.lang == 'ar' ? FieldValue.CHANEL_ONLINE_AR : FieldValue.CHANEL_ONLINE_EN,
        DCChannel: ''
      }
    };
    this.api.post(ApiRoot.DCCICPIntegration, ApiEndPoints.GET_USER_PROFILE_RUN_PROCESS, requestPayload)
      .subscribe({
        next: (response: any) => {
          this.logResponseErrorMessage(response, 'GET_USER_PROFILE');
          if (response?.SiebelMessage?.User) {
            const userProfile = response.SiebelMessage.User;
            this.sharedService.setUserProfile(userProfile);
            const accounts = Utils.checkIsArray(userProfile.Account);
            const primaryCsn = userProfile['Primary CSN'];
            const primaryAccount = accounts.find((acc: any) => acc.CSN === primaryCsn) || accounts[0];
            if (primaryAccount) {
              this.sharedService.setPrimaryAccount(primaryAccount);
            }
          }
        },
        error: () => {
          this.favProfileLoading = false;
        },
        complete: () => {
          this.favProfileLoading = false;
          const accountId = this.getPrimaryAccountId();
          if (accountId) {
            onReady(accountId);
          }
        }
      });
  }

  private logResponseErrorMessage(response: any, context: string): void {
    if (environment.production) {
      return;
    }
    const errorMessage = response?.['Error Message'];
    if (errorMessage) {
      console.warn(`[RunProcess] ${context}: ${errorMessage}`);
    }
  }

  /* ------------ actions ------------ */
  // This method is used to toggle fav using s
  toggleFav(s: any) {
    s.favourite = !s.favourite;
    this.submitFavouriteServices();
  }
  // This method is used to view details using s
  viewDetails(s: any) {
    this.router.navigate([RoutesPath.SERVICE_DETAIL + '/' + s.id]);
  }
  // This method is used to start service using s
  startService(s: any) {
    if (!s?.id) return;
    if (!this.sharedService.isServiceAllowed(s, this.serviceAccessFlags)) {
      this.sharedService.toastMessage('ERROR', 'SERVICE_NOT_AUTHORIZED', 'error');
      return;
    }
    this.router.navigate([RoutesPath.SERVICE + '/' + s.id]);
  }
  gotoServiceManuals() {
    this.sharedService.downloadServiceManual();
  }
}
